<template>
    <div class="bg-grey-50 bg-opacity-90 rounded-lg h-full w-full flex items-center">
        <div class="text-xl font-medium w-full h-full flex items-center justify-center">
            <div class="flex flex-col justify-center items-center gap-5">
                <img :src="logoBadgeUrl" alt="" style="width: 32px;" class="animate-bounce">
                <div v-if="hasOptions">
                    {{ currentItem }}
                </div>
                <div v-else>
                    {{ trans('global.loading') }}...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ElevatorLoadingState',

    props: {
        options: {
            type: Array,
            required: true,
        },
        speedInMs: {
            type: Number,
            default: 2000,
        },
    },

    data() {
        return {
            currentItemIndex: null,
            timer: null,
        };
    },

    mounted() {
        this.currentItemIndex = null;
        this.moveToNextItem();
    },

    methods: {
        moveToNextItem() {
            if (! this.hasOptions) {
                return;
            }

            if (this.currentItemIndex === this.options.length - 1) {
                return;
            }

            if (this.currentItemIndex === null) {
                this.currentItemIndex = 0;
            } else {
                this.currentItemIndex += 1;
            }

            // Add some randomness to the speed, +/- 20%
            const nextStepSpeed = this.speedInMs + (Math.random() * this.speedInMs * 0.4) - (this.speedInMs * 0.2);

            this.timer = setTimeout(() => {
                this.moveToNextItem();
            }, nextStepSpeed);
        }
    },

    beforeUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    },

    computed: {
        hasOptions() {
            return this.options && this.options.length > 0;
        },

        currentItem() {
            return this.options[this.currentItemIndex];
        },

        logoBadgeUrl() {
            return Config.get('brands.' + this.$store.state.brand + '.logo_badge_png');
        },
    },
};
</script>
